import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";

const OutletContext = createContext();

export const OutletProvider = ({ children }) => {
  const [outletOptions, setOutletOptions] = useState([]);
  const [defaultOutlet, setDefaultOutlet] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOutlets = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/outlets`,
          { token: "test" }
        );

        const outlets = response.data.map((outlet) => outlet.name);
        setOutletOptions(outlets);
        setDefaultOutlet(outlets[0] || null);
      } catch (err) {
        setError("Failed to fetch outlets. Please try again.");
        console.error("Error fetching outlets:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOutlets();
  }, []);

  return (
    <OutletContext.Provider value={{ outletOptions, defaultOutlet, setDefaultOutlet, error, loading }}>
      {children}
    </OutletContext.Provider>
  );
};

export const useOutlet = () => useContext(OutletContext);
